var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result-image-container"},[_c('ResultImage',{attrs:{"image":_vm.resultImage,"isActive":[
        _vm.Routes.result.name,
        _vm.Routes.register.name,
        _vm.Routes.completion.name
      ].includes(_vm.currentRoute),"zoomIn":[_vm.Routes.register.name, _vm.Routes.completion.name].includes(_vm.currentRoute),"zoomIn2":[_vm.Routes.completion.name].includes(_vm.currentRoute),"move":_vm.scrollContentPosition}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }